import { create } from 'zustand';

/**
 * 侧栏「坐席工作台」上的数字角标：坐席离开工作台后，本人承办的在线会话有新访客消息 / 新会话派到本人时计数。
 *
 * 计数口径是**会话数**，不是消息条数——角标回答的是「有几个会话需要我回去看」，
 * 一个访客连发十条不该把角标顶成 10。同一会话多次更新只占一个名额。
 *
 * 只活在内存、进入工作台即清零（由 BasicLayout 按路由驱动）：
 * 刷新页面后会话本身仍在工作台会话列表中可见，回填陈旧角标反而误导。
 */
interface WorkbenchBadgeStore {
  /** 有更新的会话 id（去重） */
  ids: number[];
  /** 记一次会话更新（已在集合内则不变） */
  bump: (sessionId: number) => void;
  /** 会话已结束：从集合移除，避免角标挂着一条已关闭的会话 */
  drop: (sessionId: number) => void;
  clear: () => void;
}

export const useWorkbenchBadge = create<WorkbenchBadgeStore>((set) => ({
  ids: [],
  bump: (sessionId) =>
    set((s) => (sessionId > 0 && !s.ids.includes(sessionId) ? { ids: [...s.ids, sessionId] } : s)),
  drop: (sessionId) => set((s) => (s.ids.includes(sessionId) ? { ids: s.ids.filter((id) => id !== sessionId) } : s)),
  clear: () => set((s) => (s.ids.length ? { ids: [] } : s)),
}));
